import {request} from "./request";

export function GetPhysicalTestInfoById(id) {
  return request({
    url: 'student/GetPhysicalTestInfoById',
    params: {
      id
    }
  })
}

export function GetPhysicalTestCountByKey(key) {
  return request({
    url: 'student/GetPhysicalTestCountByKey',
    params: {
      key
    }
  })
}

export function GetPhysicalTestListLikeKeyByPage(key, page) {
  return request({
    url: 'student/GetPhysicalTestListLikeKeyByPage',
    params: {
      key,
      page
    }
  })
}
